import { Component, output } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-locations-add-box',
  imports: [Button, NgIcon, TranslocoPipe],
  templateUrl: './locations-add-box.html',
})
export class LocationsAddBox {
  clickAdd = output();
}
